import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { CALENDLY_URL } from "@/lib/config";

export default function FinalCTA() {
  return (
    <section
      data-testid="final-cta-section"
      className="relative py-24 md:py-32 border-t border-border"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 14 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="relative overflow-hidden rounded-3xl border border-border bg-card px-6 sm:px-10 md:px-16 py-20 md:py-28 text-center"
        >
          {/* grid bg */}
          <div className="absolute inset-0 bg-grid-sm opacity-40 radial-fade pointer-events-none" />

          {/* accent glow */}
          <div
            className="absolute -top-32 left-1/2 -translate-x-1/2 w-[700px] h-[400px] rounded-full pointer-events-none"
            style={{
              background:
                "radial-gradient(ellipse at center, hsl(var(--accent) / 0.18), transparent 65%)",
              filter: "blur(50px)",
            }}
          />

          <div className="relative">
            <h2
              data-testid="final-cta-heading"
              className="font-display font-semibold text-balance text-4xl sm:text-5xl md:text-6xl leading-[1.04] tracking-[-0.025em] max-w-3xl mx-auto"
            >
              Ready to replace repetitive QA with autonomous{" "}
              <span className="text-[hsl(var(--accent))]">Product Quality Engineering</span>?
            </h2>

            <p
              data-testid="final-cta-note"
              className="mt-7 text-muted-foreground max-w-xl mx-auto leading-relaxed"
            >
              See how Liskov AI understands your codebase and performs exhaustive
              exploratory testing — before your users do.
            </p>

            <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-3">
              <a
                data-testid="final-cta-button"
                href={CALENDLY_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-primary group !px-7 !py-3.5 text-base"
              >
                Schedule Demo
                <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
              </a>
            </div>

            <div className="mt-10 flex items-center justify-center gap-3 mono-label text-muted-foreground">
              <span>Built for modern engineering teams</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
